import PropTypes from 'prop-types';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { FormattedMessage } from 'react-intl';
import { Message } from './Message';
import { jsx as _jsx } from "react/jsx-runtime";
export function NetworkErrorMessage(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/_jsx(Message, {
    variant: "danger",
    icon: ExclamationTriangleFill,
    onClose: onClose,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      id: "message.network_error"
    })
  });
}
NetworkErrorMessage.propTypes = {
  onClose: PropTypes.func.isRequired
};